import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { DeleteDialog, DeleteDialogProps } from 'shared/mui/Dialogs';

export const WorkTeamsDeleteDialog: React.FC<Omit<DeleteDialogProps, 'details' | 'title'>> = (
  props,
) => {
  const { goBack } = useGoBack();
  const notify = useNotify();

  const onSuccess = async () => {
    goBack();
    await queryClient.invalidateQueries({ queryKey: [Resources.WorkTeams] });

    notify(`Рабочая группа ${props.record?.name} удалена`, { type: 'success' });
  };

  return (
    <DeleteDialog
      {...props}
      details={`Рабочая группа ${props.record?.name} будет удалена без возможности восстановления.`}
      onSuccess={onSuccess}
      title="Удаление рабочей группы"
    />
  );
};
